import React from 'react';

const StatusBadge = ({ status }) => {
  const styles = {
    available: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    occupied: 'bg-blue-100 text-blue-800 border-blue-200',
    reserved: 'bg-amber-100 text-amber-800 border-amber-200',
    maintenance: 'bg-rose-100 text-rose-800 border-rose-200',
    inactive: 'bg-slate-100 text-slate-800 border-slate-200',
    active: 'bg-emerald-100 text-emerald-800 border-emerald-200'
  };

  const currentStyle = styles[status] || styles.inactive;

  return (
    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold border capitalize ${currentStyle}`}>
      {status}
    </span>
  );
};

export default StatusBadge;